
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1417199462e6bf62f5f9fb176ff997a6.jpg"
          alt="リラックスした患者様"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="bg-white/85 backdrop-blur-sm rounded-[24px] sm:rounded-[32px] md:rounded-[40px] p-8 sm:p-12 md:p-16 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-primary mb-4 sm:mb-6 leading-tight">
            あなたの健康<br />
            私たちにお任せください
          </h2>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg mb-8 sm:mb-10 leading-relaxed px-2">
            <strong>初回限定割引実施中</strong> / <strong>完全予約制で待ち時間なし</strong><br />
            <strong>岡山市北区</strong>で<strong>痛みの根本改善</strong>をお考えなら、おかやま鍼灸院へ
          </p>
          <Link
            to="/booking"
            className="inline-flex items-center gap-3 sm:gap-4 bg-primary text-white px-6 sm:px-8 md:px-10 py-4 sm:py-5 rounded-full font-medium text-base sm:text-lg hover:bg-primary-dark transition-all shadow-xl whitespace-nowrap cursor-pointer group"
          >
            <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-accent rounded-full">
              <i className="ri-phone-fill text-white text-lg sm:text-xl"></i>
            </div>
            <span>今すぐ予約する</span>
            <i className="ri-arrow-right-up-line text-xl sm:text-2xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
